module.exports = __webpack_public_path__ + "static/media/cards-icon.4f6de092.svg";